import { render, staticRenderFns } from "./BoxFlowPlanContactForm.vue?vue&type=template&id=12b2c0e1&"
import script from "./BoxFlowPlanContactForm.vue?vue&type=script&lang=js&"
export * from "./BoxFlowPlanContactForm.vue?vue&type=script&lang=js&"
import style0 from "./BoxFlowPlanContactForm.vue?vue&type=style&index=0&id=12b2c0e1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QForm,QInput,QBtn,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QForm,QInput,QBtn,QInnerLoading,QSpinnerTail})
